import { render, staticRenderFns } from "./ArticleAuthorVerificationList.vue?vue&type=template&id=34008e86&scoped=true"
import script from "./ArticleAuthorVerificationList.vue?vue&type=script&lang=js"
export * from "./ArticleAuthorVerificationList.vue?vue&type=script&lang=js"
import style0 from "./ArticleAuthorVerificationList.vue?vue&type=style&index=0&id=34008e86&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34008e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34008e86')) {
      api.createRecord('34008e86', component.options)
    } else {
      api.reload('34008e86', component.options)
    }
    module.hot.accept("./ArticleAuthorVerificationList.vue?vue&type=template&id=34008e86&scoped=true", function () {
      api.rerender('34008e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/articleAuthorVerification/ArticleAuthorVerificationList.vue"
export default component.exports